export const API_PATH_apiWorkzoneItemDelete = '/services/workzones-management/item';
